module.exports = __webpack_public_path__ + "static/media/m_beard_shortboxed_diamond__v_vector.e4e0cb24.svg";